import React from 'react';
import stripTags from 'striptags';

import { AdvizedToplist, FeaturedArticlesSlice, Product } from 'types';
import { FeaturedCategoryArticle } from 'src/components/featured-category-article';
import { CategoryPageExpertToplist } from 'src/areas/expert/toplists/components/product-toplist';
import { plainText } from 'src/areas/editorial-content/components/slices/rich-text';

import * as S from './styles';

function getExpertProducts(
  featuredArticlesSlice: FeaturedArticlesSlice
): Product[] | undefined | null {
  const primarySlice =
    featuredArticlesSlice?.featuredArticle?.data.body[0]?.primary;

  if (primarySlice?.__typename !== 'PrismicSliceProductList') {
    return undefined;
  }

  return primarySlice.products;
}

interface FeaturedArticlesProps {
  featuredArticlesSlice: FeaturedArticlesSlice;
}

function FeaturedArticles({ featuredArticlesSlice }: FeaturedArticlesProps) {
  const toplistArticles =
    featuredArticlesSlice.toplistArticles?.filter(
      (obj): obj is AdvizedToplist => Boolean(obj)
    ) ?? [];

  return (
    <S.GridWrapper>
      {toplistArticles.map(article => {
        const imageUrl = article.description?.find(
          node => node.type === 'image'
        )?.data;
        const firstParagraph = article.description?.find(
          node => node.type === 'text'
        )?.data;
        return (
          <S.GridArticleWrapper key={article.id}>
            <FeaturedCategoryArticle
              expert={article.expert}
              key={article.id}
              pathName={article.headlineInfo.url || ''}
              imageUrl={imageUrl}
              title={article.title || ''}
              preamble={firstParagraph && stripTags(firstParagraph)}
              category={article.category}
            />
            {article.pjProducts && (
              <CategoryPageExpertToplist products={article.pjProducts} />
            )}
          </S.GridArticleWrapper>
        );
      })}
      {featuredArticlesSlice.featuredArticle ? (
        <S.GridArticleWrapper key={featuredArticlesSlice.featuredArticle.id}>
          <FeaturedCategoryArticle
            pathName={`/${featuredArticlesSlice.featuredArticle.pathName}`}
            imageUrl={
              featuredArticlesSlice.featuredArticle.data.featuredImage &&
              featuredArticlesSlice.featuredArticle.data.featuredImage.url
            }
            title={plainText(featuredArticlesSlice.featuredArticle.data.title)}
            preamble={plainText(
              featuredArticlesSlice.featuredArticle.data.metaDescription
            )}
          />
          <CategoryPageExpertToplist
            isTopList={false}
            products={getExpertProducts(featuredArticlesSlice)}
          />
        </S.GridArticleWrapper>
      ) : null}
    </S.GridWrapper>
  );
}

export { FeaturedArticles };
